import {useMemo, useState} from 'react';
import {StyleSheet, View, TextInput as TextInputBase} from 'react-native';
import {theme} from 'config/themes';

import type {TextInputProps as TextInputPropsBase} from 'react-native';

export interface TextInputProps extends TextInputPropsBase {
  selectInput?: | 'none' | 'all' | 'filename',
  inputRef?: any,
}

export function TextInput(props: TextInputProps) {
  const initialSelection = useMemo(() => {
    const mode = props?.selectInput;
    const value = props?.defaultValue;
    if (!value || !mode || mode === 'none')
      return undefined;
    const ext = value?.indexOf('.') !== -1 && value.split('.')?.slice(0, -1)?.join('.');
    const end = mode === 'filename' ? ext.length : value.length;
    return {start: 0, end};
  }, [props?.defaultValue, props?.selectInput]);

  const [selection, setSelection] = useState(initialSelection);

  return (
    <View style={styles.field}>
      <TextInputBase
        {...props}
        style={styles.input}
        selection={selection}
        selectionColor={theme.app.selection}
        onChange={() => setSelection(undefined)}
        onSelectionChange={() => setSelection(undefined)}
        placeholderTextColor={props?.placeholderTextColor ?? theme.dialog.input.placeholder}
      />
    </View>
  );
}

export const styles = StyleSheet.create({
  field: {
    height: 54,
  },
  fieldActive: {
    backgroundColor: theme.app.logo,
  },
  input: {
    flex: 1,
    fontSize: 16,
    paddingVertical: 10,
    paddingHorizontal: 10,
    color: theme.dialog.input.text,
    backgroundColor: theme.dialog.input.fill,
    borderRadius: 3,
  },
});
